require('./butfly');
require('./useractivity');

const Room = require('./room');
const Autocomplete = require('./lib/autocomplete');
const AutocompletionForm = require('./autocompletionform');

let Settings = require('./settings');
let MessagePreprocessor = require('./ui/messagepreprocessor');
let Message = require('./ui/message');

global.Chat = {
	$root: null,
	isScrolledEnd: false,
	wschat: null,
	address: 'wss://sinair.ru/ws/chat',
	ukey: false,

	tries: 0,
	triesTimeout: null,

	syscolor1: 'gold',
	syscolor2: 'skyblue',

	rooms: [],
	curRoom: null,

	init($root){
		let self = this;

		this.$root = $root;

		Settings.load();
		MessagePreprocessor.init();

		this.initMessageInput();
		this.initToolsButtons();
		this.initRoomsList();
		this.initMessageButtons();

		UserActivity.onUserActivityChanged.on(function(active){
			self.onAwayStatusChanged(!active);
		});

		$root.find('.chat-messages-scroll').scroll(function(e){
			self.isScrolledEnd = self.isNeedScrollToEnd();
		});
	},

	initMessageInput(){
		let self = this;
		let $root = this.$root;

		let $ipt = $root.find('.chat-input-message');
		let $sipt = $ipt.clone();
		$sipt.removeClass('chat-input-message');
		$sipt.css({
			display: 'none',
			height: 'auto',
			'box-sizing': 'border-box',
			border: 'none',
			margin: '0',
			padding: '15px',
			background: 'none',
			'overflow': 'hidden',
			outline: 'none',
			resize: 'none',
		});
		$sipt.appendTo('body');

		let ipt_resize = function(e){
			let scrl = self.isScrolledEnd;
			let $me = $(this);

			$sipt.width($me.width());
			$sipt.val($me.val());
			$sipt.css('display', 'inline-block');
			let nh = $sipt[0].scrollHeight;
			$sipt.css('display', 'none');

			if (nh > 150){
				nh = 150;
			}

			if (nh != $me.css('height')){
				$me.css('height', nh + 'px');
			}

			if (scrl){
				self.scrollToEnd();
			}
		};

		$root.find('.chat-button-send').click(function(){
			let $msg = $root.find('.chat-input-message');
			if ($msg.val().match(/[^\s]/) != null){
				if (self.send($msg.val())){
					$msg.val('');
					self.autocompletion.resetCompletionsForm();
					setTimeout(ipt_resize.bind($ipt, null), 1);
					self.setTyping(false);
				}
			}
		});

		this.autocompletion = new Autocomplete($ipt[0], {
			ui: new AutocompletionForm($root.find('.chat-autocomplete-form')[0]),
			completions(part){
				if (part.length == 0 || part[0] != '@' && part[0] != ':'){
					return [];
				}

				let type = part[0];

				if (type == '@'){
					part = part.substr(1);
					return self.curRoom.getMembers().filter((x) => x.name.substr(0, part.length) == part).map((x) => '@' + x.name);
				} else if (type == ':') {
					return MessagePreprocessor.smileCodes.filter((x) => x.substr(0, part.length) == part);
				}

				return [];
			},
		});

		$ipt.keydown(function(e){
			let $me = $(this);

			if (e.keyCode == 13){
				if (e.shiftKey){
					return;
				} else {
					$root.find('.chat-button-send').click();
				}

				e.preventDefault();
			}
			else if (e.keyCode == 9){
				e.preventDefault();
			}
		}).on('input', function(){
			ipt_resize.apply(this);
			self.setTyping(true);
		});
	},

	initToolsButtons(){
		let self = this;
		let $root = this.$root;

		let hideMenu = () => {
			if ($root.find('.chat-menu').hasClass('visible')){
				$root.find('.chat-menu').removeClass('visible');
			}
		};

		let $opts = $root.find('.chat-settings-area .chat-settings-option .chat-settings-input');

		$opts.filter('[name=mention]').on('change-option', (e, val) => {
			if (val && !Settings.isNotificationPermissionGranted() && Notification !== undefined){
				Notification.requestPermission();
			}
		});

		$opts.filter('[name=typing]').on('change-option', (e, val) => {
			if (val){
				$root.find('.chat-typing').show();
			} else {
				$root.find('.chat-typing').hide();
			}
		});

		$opts.each((i, el) => {
			let $el = $(el);
			let name = $el.attr('name');

			switch ($el.attr('type')){
				case 'checkbox':
					$el.prop('checked', Settings[name]);
					break;

				case 'radio':
					$el.find('[value="' + Settings[name] + '"]').prop('checked', true);
					break;
			}

			$el.trigger('change-option', Settings[name]);

			$el.change((e) => {
				let val = null;

				switch ($el.attr('type')){
					case 'checkbox':
						val = $el.prop('checked');
						break;

					case 'radio':
						val = $el.find(':checked').val();
						break;
				}

				if (val !== null){
					Settings[name] = val;
					Settings.save();
					$el.trigger('change-option', [val]);
				}
			});
		});

		$root.find('.chat-button-menu').click(function(e){
			let $pan = $root.find('.chat-menu');
			if ($pan.css('display') == 'none'){
				$pan.addClass('visible');
			} else {
				$pan.removeClass('visible');
			}
		});

		$root.find('.chat-button-settings').click(function(e){
			hideMenu();
			let $msg = $root.find('.chat-messages-area');
			let $set = $root.find('.chat-settings-area');

			if ($msg.css('display') == 'none'){
				$msg.show();
				$set.hide();
			} else {
				$msg.hide();
				$set.show();
			}
		});

		$root.find('.chat-button-close-settings').click(function(e){
			self.$root.find('.chat-messages-area').show();
			self.$root.find('.chat-settings-area').hide();
		});

		$root.find('.chat-button-show-online-list').click(function(e){
			let $pan = self.$root.find('.chat-messages-area .chat-online-box');
			if ($pan.css('display') == 'none'){
				$pan.show();
			} else {
				$pan.hide();
			}
		});

		$root.find('.chat-button-create-room').click(function(e){
			hideMenu();

			let name = prompt('Введите имя комнаты: ');

			if (name == null){
				return;
			}

			if (name[0] != '#'){
				name = '#' + name;
			}

			self.wschat.createRoom(name);
		});

		$root.find('.chat-button-remove-room').click(function(e){
			hideMenu();

			if (confirm('Вы действительно хотите удалить текущую комнату?')){
				if (self.curRoom != null){
					self.wschat.removeRoom(self.curRoom.wsroom.getTarget());
				} else {
					alert('Текущая комната не выбрана!');
				}
			}
		});
	},

	initMessageButtons(){
		let self = this;
		this.$root.find('.chat-messages').on('click', '.chat-msg-time', function(e){
			let $msg = $(this).closest('.chat-msg');
			let q = '> ';
			q += $msg.find('.chat-msg-time').text();
			q += ' ';
			q += $msg.find('.chat-msg-author').text();
			q += ' ';
			q += $msg.find('.chat-msg-body').text().replace(/\n/g, '\n> ');
			q += '\n\n';

			let $ipt = self.$root.find('.chat-input-message');
			$ipt.focus();
			$ipt[0].setRangeText(q);
			$ipt[0].selectionStart += q.length;
			$ipt.trigger('input');
		});
	},

	initRoomsList(){
		let self = this;
		let $root = this.$root;

		$root.find('.chat-rooms-list').on('click', 'li', function(e){
			let $me = $(this);
			self.selectRoom($me.attr('data-target'));
		}).on('click', 'li > .chat-button-leave-room', function(e){
			let $li = $(this).closest('li');
			self.leaveRoom($li.attr('data-target'));

			return false;
		});

		$root.find('.chat-messages').on('click', '.chat-message-room-link', function(e){
			self.joinRoom($(this).text());
			return false;
		});

		$root.find('.chat-rooms-block .chat-button-join-room').click(function(e){
			let target = prompt('Введите имя комнаты:');

			if (target == null){
				return;
			}

			if (target[0] != '#'){
				target = '#' + target;
			}

			self.joinRoom(target);
		});
	},

	connect(){
		if (this.wschat){
			this.wschat.close();
			this.wschat = null;
		}

		this.ukey = this.$root.attr('data-ukey') != '';

		let me = this;

		console.log(this.address);
		let wschat = new WsChat(this.address);
		this.wschat = wschat;

		let joinRooms = function(){
			if (me.rooms.length <= 0){
				me.joinRoom('#chat');
			} else {
				for (let i in me.rooms){
					let room = me.rooms[i];
					me.joinRoom(room.wsroom.getTarget());
				}
			}
		};

		wschat.onOpen = function(){
			me.addSysMsg('Вы подключились к чату');
			me.triesTimeout = setTimeout(function(){
				me.tries = 0;
				me.triesTimeout = null;
			}, 10000);

			if (me.ukey){
				$.get('/chat/authkey', function(data){
					me.wschat.authByKey(data);
					joinRooms();
				});
			} else {
				joinRooms();
			}
		};

		wschat.onClose = function(){
			let $list = me.$root.find('.chat-online-list');
			$list.html('');

			if (++me.tries > 3){
				me.addSysMsg('Ошибка подключения. Возможно, сервер недоступен.');
			} else {
				if (me.triesTimeout){
					clearTimeout(me.triesTimeout);
				}
				me.addSysMsg('Соединение с сервером было закрыто. Переподключение через 10 сек...');
				setTimeout(me.connect.bind(me), 10000);
			}
		};

		wschat.onConnectionError = function(err){
			console.log(err);
		};

		wschat.onError = function(err){
			console.log(err);
			alert(err.info);
		};

		wschat.onJoinedRoom = function(wsroom){
			let target = wsroom.getTarget();
			let room = me.getRoomByName(target);

			if (room == null){
				room = me.createRoom(wsroom);
			} else {
				me.createRoomTab(room);
				room.wsroom = wsroom;
			}

			room.onJoined();
			me.selectRoom(target);
			me.onJoinRoom(room);
		};

		wschat.onLeaveRoom = function(wsroom){
			let room = me.getRoomByName(wsroom.getTarget());
			if (room){
				me.onLeaveRoom(room);
			}
		};

		wschat.onRoomCreated = function(target){
			me.joinRoom(target);
		};

		wschat.onRoomRemoved = function(target){
			//none
		};

		wschat.onMessage = function(wsroom, msg){
			let room = me.getRoomByName(wsroom.getTarget());
			if (room) room.onMessage(msg);
		};

		wschat.onSysMessage = function(wsroom, text){
			let target = wsroom.getTarget();
			if (target == ''){
				alert(text);
				return;
			}

			let room = me.getRoomByName(target);
			if (room) room.onSysMessage(text);
		};

		wschat.onUserStatusChanged = function(wsroom, user){
			let room = me.getRoomByName(wsroom.getTarget());
			if (room) room.onUserStatusChanged(user);
		};

		wschat.onUserConnected = function(wsroom, user){
			let room = me.getRoomByName(wsroom.getTarget());
			if (room) room.onUserStatusChanged(user);
		};

		wschat.onUserDisconnected = function(wsroom, user){
			let room = me.getRoomByName(wsroom.getTarget());
			if (room) room.onUserStatusChanged(user);
		};

		wschat.open();
	},

	setOnlineList(members){
		let $list = this.$root.find('.chat-online-list');
		let needScroll = this.isNeedScrollToEnd();

		$list.html('');
		for (let i in members){
			let item = members[i];

			let $p = $('<li/>');
			let $name = $('<span/>');
			$name.text(item.name);
			$name.css({
				color: item.color,
			});
			$p.addClass(item.status == UserStatus.away ? 'status-away' : 'status-online');

			if (item.user_id != 0){
				let $a = $('<a/>');
				$a.attr('href', '//sinair.ru/profile/' + item.user_id);
				$a.attr('target', '_blank');
				$a.append($name);

				$p.append($a);
			} else {
				$p.append($name);
			}
			$list.append($p);
		}

		this.$root.find('.chat-online-counter').text(members.length);

		if (needScroll){
			this.scrollToEnd();
		}
	},

	setMessages(room, msgs){
		let $chat = this.$root.find('.chat-messages');
		let html = '';
		for (let i in msgs){
			if (!msgs[i].cachedHtml){
				let $m = Message.format(room, msgs[i]);
				msgs[i].cachedHtml = $m[0].outerHTML;
			}
			html += msgs[i].cachedHtml;
		}

		$chat.html(html);
		this.scrollToEnd();
	},

	setTypingList(list){
		let $typing = this.$root.find('.chat-typing');

		if (!Settings.typing || list.length == 0){
			$typing.text('');
			return;
		}

		let names = [];
		for (let i in list){
			names.push(list[i].name);
		}

		$typing.text(names.join(', ') + (list.length > 1 ? ' печатают...' : ' печатает...'));
	},

	send(msg){
		if (this.curRoom != null){
			if (msg == '/clear'){
				this.$root.find('.chat-messages').html('');
				this.curRoom.clearMessages();
				this.curRoom.onSysMessage('Ваш чат был очищен');
				return true;
			}
			else if (msg.substr(0, 4) == '/re '){
				let mid = this.curRoom.getLastPMMemberId();
				if (mid){
					msg = '/umsg ' + mid + ' ' + msg.substr(4);
				} else {
					this.curRoom.onSysMessage('Вам еще никто не писал в ЛС');
					return false;
				}
			}

			this.curRoom.wsroom.sendMessage(msg);
			return true;
		}
	},

	addSysMsg(msg){
		this.addFormattedMsg({
			type: 'sysmessage',
			time: Date.now(),
			body: msg,
		});
	},

	addFormattedMsg(fmt){
		let $p = Message.format(null, fmt);
		this.addRawMsg($p);
	},

	addRawMsg($msg){
		let $chat = this.$root.find('.chat-messages');
		let needScroll = this.isNeedScrollToEnd();

		$msg.appendTo($chat);

		if (needScroll){
			this.scrollToEnd();
		}
	},

	isNeedScrollToEnd(){
		let $chat = this.$root.find('.chat-messages-scroll');
		if ($chat[0].scrollHeight - $chat.height() - $chat.scrollTop() < 5){
			return true;
		}

		return false;
	},

	scrollToEnd(){
		let $chat = this.$root.find('.chat-messages-scroll');
		$chat.scrollTop($chat[0].scrollHeight);
	},

	setTyping(val){
		if (Settings.typing && this.curRoom){
			this.curRoom.setTyping(val);
		}
	},

	firstRun(){
		Settings.save();
		if (!Settings.isNotificationPermissionGranted()){
			// if (confirm('Похоже, вы впервый раз в чате. '
			// 	+ 'Хотите включить всплывающие уведомления при @упоминаниях вашего ника? '
			// 	+ 'Отключить их всегда будет можно в настройках')
			// ){
			// 	this.$root.find('.chat-button-mention').click();
			// }
		}
	},

	//rooms local

	getRoomByName(name){
		for (let i in this.rooms){
			let room = this.rooms[i];
			if (name == room.wsroom.getTarget()){
				return room;
			}
		}

		return null;
	},

	joinRoom(target){
		this.wschat.joinRoom({
			target: target,
			autoLogin: true,
			loadHistory: true,
		});
	},

	removeRoom(room){
		this.removeRoomTab(room.wsroom.getTarget());
		this.rooms = this.rooms.filter(function(el){ return el != room; });
	},

	createRoom(wsroom){
		let room = new Room(this, wsroom);
		this.rooms.push(room);
		this.createRoomTab(room);
		return room;
	},

	createRoomTab(room){
		if (this.getRoomTabByName(room.wsroom.getTarget()).length > 0){
			return;
		}

		let $l = this.$root.find('.chat-rooms-list');
		let $btn = $('<img class="chat-button-leave-room" src="/res/i/delete.png" title="Покинуть комнату"/>');
		let $li = $('<li/>');
		let $sp = $('<span/>');
		$sp.text(room.wsroom.getTarget());
		$li.attr('data-target', room.wsroom.getTarget());

		$li.append($sp, $btn);

		$l.append($li);
	},

	removeRoomTab(name){
		this.getRoomTabByName(name).remove();
	},

	getRoomTabByName(name){
		return this.$root.find('.chat-rooms-list li[data-target="' + name + '"]');
	},

	selectRoom(name){
		if (this.curRoom == null || this.curRoom.wsroom.getTarget() != name){
			let room = null;
			if (name != ''){
				room = this.getRoomByName(name);
			} else if (this.rooms.length > 0){
				room = this.rooms[0];
			}

			if (room){
				let $list = this.$root.find('.chat-rooms-list');
				$list.find('li.active').removeClass('active');
				this.getRoomTabByName(room.wsroom.getTarget()).addClass('active');
				this.curRoom = room;
				this.setMessages(room, room.getMessages());
				this.setOnlineList(room.getMembers());
				this.setTypingList(room.getTypingMembers());

				room.unread = 0;
				this.onUpdateUnread(room);
			}
		}
	},

	// rooms server

	leaveRoom(name){
		let room = this.getRoomByName(name);
		if (room != null){
			this.onLeaveRoom(room);
		} else {
			this.removeRoomTab(name);
		}

		this.wschat.leaveRoom(name);
	},

	//events

	onChatMessage(room, msg){
		if (this.curRoom == room){
			if (!msg.cachedHtml){
				let $m = Message.format(room, msg);
				msg.cachedHtml = $m[0].outerHTML;
			}
			this.addRawMsg($(msg.cachedHtml));
		} else {
			++room.unread;
			this.onUpdateUnread(room);
		}
	},

	onOnlineListChanged(room, list){
		if (this.curRoom == room){
			this.setOnlineList(list);
		}
	},

	onTypingListChanged(room, list){
		if (this.curRoom == room){
			this.setTypingList(list);
		}
	},

	onJoinRoom(room){
		this.onOnlineListChanged(room, room.getMembers());
	},

	onLeaveRoom(room){
		this.removeRoom(room);

		if (this.curRoom.wsroom.getTarget() == room.wsroom.getTarget()){
			this.selectRoom('');
		}
	},

	onUpdateUnread(room){
		let $t = this.getRoomTabByName(room.wsroom.getTarget());
		if (room.unread > 0){
			$t.find('span').text(room.wsroom.getTarget() + ' (' + room.unread + ')');
		} else {
			$t.find('span').text(room.wsroom.getTarget());
		}
	},

	onAwayStatusChanged(isAway){
		if (this.wschat != null){
			this.wschat.changeStatus(isAway ? UserStatus.away : UserStatus.back);
		}
	},
};
